

import React, { memo, useState, useCallback, useEffect } from 'react';
import { formatDate, DATE_FORMAT } from '@shootsta/get-moment';
import { FormModal, Icon, Input, Row, Col, Text, Checkbox, List } from '../../../../ui-kit';

import './styles/_elevate-link.scss';













const LinkElevateTemplates = (props) => {
  const {
    title,
    visible,
    onClose,
    templateId,
    setTemplateDetails,
    getElevateTemplatesByOrg,
    updatePitchSplashLink,
    isInternalAdmin
  } = props;

  const [selectedIds, setSelectedIds] = useState([]);
  const [totalElevateTemplates, setTotalElevateTemplates] = useState(null);
  const [searchableElevateTemplates, setSearchableElevateTemplates] = useState(null);


  const getElevateTemplateDetails = useCallback(async () => {
    const filters = {
      where: {
        // don't go by the variable name isInternalAdmin,
        // it is just a flag sent from the client facing side of the platform to distinguish
        // between internal and client facing users
        includeGlobal: isInternalAdmin,
        searchTerm: '',
        status: 'ALL'
      }
    };

    const { data, error } = await getElevateTemplatesByOrg(filters);
    if (!error && data && data.getTemplatesByOrg) {
      setTotalElevateTemplates(data.getTemplatesByOrg);
      setSearchableElevateTemplates(data.getTemplatesByOrg);
    } else {
      setTotalElevateTemplates([]);
      setSearchableElevateTemplates([]);
    }
  }, [getElevateTemplatesByOrg, isInternalAdmin]);

  useEffect(() => {
    getElevateTemplateDetails();
  }, [getElevateTemplateDetails]);

  const onSave = async () => {
    await Promise.all(selectedIds.map((it) => updatePitchSplashLink({
      pitchTemplateId: it,
      splashTemplateId: templateId
    })));
    setTemplateDetails();
    onClose();
  };

  const onSearchFilter = ({ target: { value } }) => {
    const elevateTemplates = totalElevateTemplates && totalElevateTemplates.filter(
      ({ templateName }) => templateName.toLowerCase().includes(value.toLowerCase())
    );
    setSearchableElevateTemplates(elevateTemplates);
  };

  const selectElevateTemplate = (template) => {
    const ids = [...selectedIds];
    const position = ids.indexOf(template.templateId);
    if (position === -1) {
      ids.push(template.templateId);
    } else {
      ids.splice(position, 1);
    }
    setSelectedIds(ids);
  };

  return (
    <FormModal
      key="elevate-link-modal"
      title={title}
      visible={visible}
      onClose={onClose}
      onSave={onSave}
      saveDisabled={!selectedIds.length}
      stayOpenOnSave
      saveText="Confirm & Save">

      {
      !searchableElevateTemplates ?
      <Icon name="shootstagrad" size={40} color="black" spin /> :

      <div className="elevate-link-modal">
            <Row nogutter className="elevate-link-modal__search">
              <Col sm={12} md={12}>
                <Text highlighted>Available Templates</Text>
                <Input
              prefix="search"
              onChange={onSearchFilter}
              clearButton={<Icon name="close" size={10} color="regent" />}
              placeholder="Search Templates" />

              </Col>
            </Row>
            {searchableElevateTemplates.length ?
        <div className="elevate-link-modal__content">
                <div className="elevate-link-modal__content__types">
                  {searchableElevateTemplates.map((elevate) =>
            <>
                      {/* $FlowFixMe */}
                      <List.CardItem
                className="elevate-link-modal__content__types__item"
                key={elevate.templateId}>

                        <Checkbox
                  lightMode
                  checked={
                  elevate.splashTemplatesDescriptorId === templateId ||
                  selectedIds.indexOf(elevate.templateId) !== -1}

                  disabled={elevate.splashTemplatesDescriptorId === templateId}
                  onChange={() => selectElevateTemplate(elevate)}>

                          <div className="elevate-link-modal__content__types__item__content">
                            <Text heading5 noMargin>{elevate.templateName}</Text>
                            <Text noMargin>
                              {formatDate(
                        elevate.updatedAt,
                        DATE_FORMAT.MONTH_SHORT_DAY_YEAR
                      )}
                            </Text>
                          </div>
                        </Checkbox>

                      </List.CardItem>
                    </>
            )}
                </div>
              </div> :

        <Text>No result found</Text>}


          </div>}



    </FormModal>);

};

export default memo(LinkElevateTemplates);